import React, { FormEvent, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';
import './index.scss';
import logoEmail from 'images/dialog/email-query.png';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { IProductLibrary } from 'store/apps/product-library';

const GameAccessModal = ({ open, close, product }: { open: any; close: any; product: IProductLibrary }) => {
    const { t } = useTranslation('game-access-restricted');
    const [rememberMe, setRememberMe] = useState(false);
    const [authCode, setAuthCode] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [resent, setResent] = useState(false);

    const resendClick = async () => {
        setResent(false);
        product
            ?.requestParentPIN()
            .then(() => {
                setResent(true);
                setTimeout(() => {
                    setResent(false);
                }, 5000);
            })
            .catch((e) => {
                setErrorMsg(`error-code:${e.code}`);
            });
    };

    function gaEvent(title: string, result?: boolean) {
        window.dataLayer.push({
            event: `Parent Verification Game Access ${title}`,
            gameName: product.displayName,
            ...(result !== undefined ? { parentalControl_Result: result ? 'Success' : 'Failure' } : {}), //ie: Success or Failure
        });
    }

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        product
            ?.verifyParentPIN(authCode, rememberMe)
            .then((d) => {
                product.fetchAccess();
                close([true, d.data]);
                gaEvent('Result', true);
            })
            .catch((e) => {
                let { code: errorCode } = e;
                if (errorCode === 20013 || errorCode < 100) {
                    if (errorCode === 20013) errorCode = 30306;
                    setErrorMsg(`error-code:${errorCode}`);
                    gaEvent('Result', false);
                } else {
                    close([false, e]);
                }
            });
    };

    // init
    useEffect(() => {
        gaEvent('Required');
        product?.requestParentPIN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Modal show={open} onHide={() => close()} backdrop="static" centered>
            <section className={classNames('game-access-restricted layerSty', { errorForm: !!errorMsg, resendSuccess: resent })}>
                <h1>{t('header')}</h1>
                <p className="errorMsg">
                    <span>{t(errorMsg)}</span>
                </p>
                <div className="container">
                    <h2>
                        <span>{t('title')}</span>
                    </h2>
                    <p>{t('desc')}</p>
                    <div className="center">
                        <img src={logoEmail} alt="email sent" />
                    </div>
                    <div className="center">
                        <span>{product?.parentEmail}</span>
                        <button onClick={resendClick}>
                            Resend
                            <span className="check" />
                        </button>
                    </div>
                    <form onSubmit={onSubmit}>
                        <div className="imgCheckbox">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={() => setRememberMe(!rememberMe)}
                                    className="autoInp"
                                />
                                {t('skip-checkbox')}
                            </label>
                        </div>
                        <input
                            type="text"
                            maxLength={6}
                            value={authCode}
                            className="auth-code-input"
                            onChange={(e) => {
                                if (e.target.validity.valid) {
                                    setAuthCode(e.target.value);
                                    setErrorMsg('');
                                }
                            }}
                            placeholder="000000"
                        />
                        <div className="bt">
                            <button type="button" className="button4" onClick={() => close()}>
                                <span>{t('dialog:cancel')}</span>
                            </button>
                            <button type="submit" className="button3">
                                <span>{t('dialog:verify')}</span>
                            </button>
                            <button type="button" className="closeBt" onClick={() => close()} />
                        </div>
                    </form>
                </div>
            </section>
        </Modal>
    );
};

export default createModal(observer(GameAccessModal));
